import { render } from "./MenuRenderer.vue?vue&type=template&id=ce4cca50&scoped=true"
import script from "./MenuRenderer.vue?vue&type=script&lang=ts"
export * from "./MenuRenderer.vue?vue&type=script&lang=ts"

import "./MenuRenderer.vue?vue&type=style&index=0&id=ce4cca50&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-ce4cca50"

export default script